import { LOCATION_INITIALIZED } from '@angular/common';
import { Injectable, Injector } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class TranslationGuard implements CanActivate {
    constructor(
        private injector: Injector,
        private translations: TranslateService,
    ) {}

    canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
        return new Promise<any>((resolve: any) => {
            const locationInitialized = this.injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
            locationInitialized.then(() => {
                this.translations.use('default').subscribe(
                    () => {},
                    () => {
                        console.error(`Problem with language initialization.'`);
                    },
                    () => {
                        resolve(true);
                    },
                );
            });
        });
    }
}
